export default __webpack_public_path__ + "static/media/train_map.254db78f.svg";